'use client'

import { useEffect } from 'react'
import ErrorPage from './ErrorPage'
import { store } from '@/app/_components/store/store'
import type { AreaId } from '@/urls'
import { previousView } from '@/utils/useViewHistory'
import { captureException } from '@nais/apm'
import { catchError, type ErrorInfo } from 'next/error'

function ViewErrorPage({ area, error, reset }: { area: AreaId; error: unknown; reset: () => void }) {
    const actions = store.useActions()
    const forrige = previousView()

    useEffect(() => {
        captureException(error, { context: { digest: (error as { digest?: string })?.digest } })
    }, [error])

    const tilForrigeSkjermbilde = forrige
        ? () => {
              const setView = {
                  arbeidsgiver: actions.SET_ARBEIDSGIVER_VIEW,
                  arbeidstaker: actions.SET_ARBEIDSTAKER_VIEW,
                  samarbeidspartner: actions.SET_SAMARBEIDSPARTNER_VIEW,
              }[area] as (view: string) => void
              setView(forrige)
              history.back()
              reset()
          }
        : undefined

    return <ErrorPage area={area} onForrigeSkjermbilde={tilForrigeSkjermbilde} />
}

// Ligger under Store, så dataene fra forrige visning overlever feilen og kan vises igjen.
export default catchError(function ViewErrorFallback({ area }: { area: AreaId }, { error, reset }: ErrorInfo) {
    return <ViewErrorPage area={area} error={error} reset={reset} />
})
